import * as React from "react";
import {useState} from "react";
import ImageComponent from "./ImageComponent";
import {
    BulkDeleteConfirmModal,
    BulkDeleteToolbar,
    useBulkImageDelete,
} from "./BulkImageDelete";


export default function AdhocImageGallary(props) {
    const {images, setImages, isReadOnly} = props

    const [isLoading] = useState(false)

    const safeSetImages = setImages || (() => {});
    const bulk = useBulkImageDelete(images || [], safeSetImages);

    const imageSize = 100
    const showBulkUi = !isReadOnly && !!setImages;

    return (
        <div>
            {showBulkUi && (
                <div style={{display: "flex", justifyContent: "flex-start", marginTop: "10px"}}>
                    <BulkDeleteToolbar
                        totalCount={images?.length || 0}
                        selectedCount={bulk.selectedIds.size}
                        allSelected={bulk.allSelected}
                        onToggleSelectAll={bulk.toggleSelectAll}
                        onDeleteSelected={bulk.openConfirm}
                    />
                </div>
            )}
            <div style={{display: 'flex', flexWrap: 'wrap', gap: '20px', marginTop: '10px',
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center'
            }}>
                {isLoading && <div>Loading Images... <img width={"100px"} src={"/loading.gif"}/></div>}

                {images && images.map((item) => (
                    <ImageComponent
                        key={item.id}
                        item={item}
                        alt={item.title}
                        loading="lazy"
                        width={imageSize}
                        height={imageSize}
                        isReadOnly={isReadOnly}
                        isSelected={bulk.selectedIds.has(item.id)}
                        onToggleSelect={showBulkUi ? bulk.toggleSelect : undefined}
                    />

                ))}
            </div>
            {showBulkUi && (
                <BulkDeleteConfirmModal
                    show={bulk.showConfirm}
                    isDeleting={bulk.isDeleting}
                    completedCount={bulk.completedCount}
                    idsToDelete={bulk.idsToDelete}
                    errors={bulk.errors}
                    onCancel={bulk.closeConfirm}
                    onConfirm={bulk.runBulkDelete}
                    onClose={bulk.closeConfirm}
                    onRequestCancel={bulk.requestCancel}
                />
            )}
        </div>

    )
}
